import http from '../lib/http';

/**
 * Get all chats for the customer
 * GET /api/customer/chats
 */
export const getAllChats = async () => {
    const response = await http.get('/api/customer/chats');
    return response.data;
};

/**
 * Get chat history/messages for a specific chat
 * GET /api/customer/chat/{chatId}/messages
 */
export const getChatMessages = async (chatId) => {
    const response = await http.get(`/api/customer/chat/${chatId}/messages`);
    return response.data;
};

/**
 * Send a message to vendor
 * POST /api/customer/chat/send
 * @param {number} productId - The product ID
 * @param {string} message - The message text
 */
export const sendMessage = async ({ productId, message }) => {
    const response = await http.post('/api/customer/chat/send', {
        product_id: productId,
        message
    });
    return response.data;
};
